var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['icon-db', _vm.row[_vm.col.field] ? 'is-true' : 'is-false']})}
var staticRenderFns = []

export { render, staticRenderFns }